type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};

const buildParentFilters = (
  includedParentId: string,
  sponsorName: string,
  issuerName: string,
): PartialRecord<'includedParentIds' | 'includedIssuerIds', string[]> => {
  if (!includedParentId) return {};

  if (sponsorName) return { includedParentIds: [includedParentId] };
  if (issuerName) return { includedIssuerIds: [includedParentId] };

  return {};
};

const buildSectorFilters = (
  sectorId: string,
  subsectorId: string,
): PartialRecord<'includedSubsectorIds' | 'includedSectorIds', string[]> => {
  if (subsectorId) return { includedSubsectorIds: [subsectorId] };
  if (sectorId) return { includedSectorIds: [sectorId] };

  return {};
};

const buildIndustryFilters = (
  industryId: string,
  subindustryId: string,
): PartialRecord<'includedSubindustryIds' | 'includedIndustryIds', string[]> => {
  if (subindustryId) return { includedSubindustryIds: [subindustryId] };
  if (industryId) return { includedIndustryIds: [industryId] };

  return {};
};

export {
  buildParentFilters,
  buildSectorFilters,
  buildIndustryFilters,
};
